// extracted by css-extract-rspack-plugin
export default {"root":"root-ups5bc","avatar":"avatar-zyoRix","avatarInput":"avatarInput-LgpnzK","spinner":"spinner-oHxMKq","pending":"pending-g9e9id"};